{
  "el": {
    "editor_ziggu": {
      "actions": {
        "apply": "Εφαρμογή",
        "cancel": "Ακύρωση",
        "link": "Σύνδεσμος",
        "showLess": "Λιγότερα",
        "showMore": "Περισσότερα"
      },
      "labels": {
        "blue": "Μπλε",
        "green": "Πράσινο",
        "link_text": "Κείμενο συνδέσμου",
        "orange": "Πορτοκαλί",
        "pink": "Ροζ",
        "purple": "Μοβ",
        "red": "Κόκκινο",
        "remove_highlight": "Αφαίρεση επισήμανσης",
        "yellow": "Κίτρινο"
      },
      "placeholders": {
        "content": "Ξεκίνα να γράφεις..",
        "link": "Γράψε ή επικόλλησε έναν σύνδεσμο"
      }
    }
  }
}
